<template>
    <v-data-table :headers="headers" :items="roles" sort-by="calories" class="elevation-1" >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Roles</v-toolbar-title>
                <v-divider class="mx-4" inset vertica></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark
                               class="mb-2"
                               v-bind="attrs"
                               v-on="on">New Role
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="editedItem.roleName" label="Role name"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-checkbox v-model="editedItem.read" label="Read"></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-checkbox v-model="editedItem.write" label="Write"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                    small
                    @click="deleteItem(item)"
            >
                mdi-delete
            </v-icon>
        </template>
        <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
    </v-data-table>
</template>

<script>
    import {CommonService, ParseRoleService} from '../../services';
    import {mapGetters} from 'vuex';

    export default {
        name: "AdminRolePanel",
        data: () => ({
            dialog: false,
            headers: [
                {
                    text: 'Role Name',
                    align: 'start',
                    sortable: true,
                    value: 'roleName',
                },
                {text: 'Read', value: 'read', sortable: true},
                {text: 'Write', value: 'write', sortable: true},
                {text: 'Actions', value: 'actions', sortable: false},
            ],
            roles: [],
            editedIndex: -1,
            editedItem: {
                role: null,
                roleName: '',
                read: false,
                write: false,
            },
            defaultItem: {
                role: null,
                roleName: '',
                read: false,
                write: false,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Role' : 'Edit Role'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            ...mapGetters({
                getRoles: 'role/getRoles'
            }),
            initialize() {
                this.roles = this.getRoles();
                if (!this.roles.length) {
                    CommonService.showLoading(true);
                    ParseRoleService.getAllRole().then(() => {
                        CommonService.showLoading(false);
                    }).catch(ex => {
                        console.log(ex);
                        CommonService.showLoading(false);
                    })
                }
            },

            editItem(item) {
                this.editedIndex = this.roles.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true
            },

            deleteItem(item) {
                const index = this.roles.indexOf(item);
                confirm('Are you sure you want to delete this item?') && this.roles.splice(index, 1)
            },

            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                })
            },

            save() {
                if (this.editedIndex > -1) {
                    this.showLoading();
                    ParseRoleService.editRole(this.editedItem).then(() => {
                        Object.assign(this.roles[this.editedIndex], this.editedItem);
                    }).catch(ex => {
                        console.log(ex);
                    }).finally(() => {
                            this.stopLoading();
                            this.close();
                        }
                    );
                } else {
                    this.showLoading();
                    ParseRoleService.addRole(this.editedItem).then((role) => {
                        this.editedItem.role = role;
                        this.$store.state.role.roles.push(this.editedItem)
                    }).catch(ex => {
                        console.log(ex);
                    }).finally(() => {
                        this.stopLoading();
                        this.close();
                    });
                }
            },
            showLoading() {
                CommonService.showLoading(true);
            },
            stopLoading() {
                CommonService.showLoading(false);
            }
        },
    }
</script>
